/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useEffect, useState } from 'react'
import {
  CalendarIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MapPinIcon,
} from '@heroicons/react/20/solid'
import Day from './Day'
import Axios from 'axios'
import Pagination from '../components-contabilidad-analisis/Pagination'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function EfectivoSinCuadrar({ url, headers, setLoadingAPIS }) {

  const currentDate = new Date()
  const [currentMonth, setMonth] = useState(currentDate.getMonth())
  const [pickDate, setpickDate] = useState('')
  const [selected, setSelected] = useState(Array(42).fill(false))
  const [dateLabel, setDateLabel] = useState('')
  const currentMonthES = new Date(2022, currentMonth, 1).toLocaleDateString('es-ES', { month: 'long' })

  //DEBO HALLAR EL PRIMER DOMINGO DEL MES QUE SE DESEA CONSULTAR

  const firstDay = new Date(currentDate.getFullYear(), currentMonth, 1)

  while (true) {
    if (firstDay.getDay() > 0) {
      firstDay.setDate(firstDay.getDate() - 1)
    }
    else if (firstDay.getDay() < 0) {
      firstDay.setDate(firstDay.getDate() + 1)
    } else {
      break
    }
  }


  //YA CON EL PRIMER DIA DEL MES LLENO LOS SIGUIENTES 42 ESPACIOS DEL CALENDARIO
  let i = 0
  const days = []
  const date = new Date(firstDay)

  while (i < 42) {
    let d = new Date(date)
    days.push({
      date: d.toLocaleDateString('es-ES').split('/').reverse().join('-'),
      isCurrentMonth: (d.getMonth() === currentMonth ? true : false),
      isToday: (d.toLocaleDateString('es-ES') === currentDate.toLocaleDateString('es-ES') ? true : false),
      isSelected: selected[i]
    })
    date.setDate(date.getDate() + 1)
    i++
  }

  //FUNCION PARA MARCAR Y DESMARCAR DIA 
  const handleSelect = (id, date) => {
    let newArr = Array(42).fill(false)
    newArr.splice(id, 0, true)
    setSelected(newArr)
    setpickDate(date)
  }

  //FUNCION PARA NAVEGAR ENTRE MESES
  const navMonth = (idx) => {
    if (idx === 1) {
      setMonth(currentMonth + 1)
    } else {
      setMonth(currentMonth - 1)
    }
    return setpickDate('')
  }

  //FUNCION PARA FORMATEAR CONSULTA
  const handleSubmit = () => {
    //console.log("click")
    const dateArr = pickDate.split('-').map(x => Number(x))
    const FFin = new Date(dateArr[0], dateArr[1] - 1, dateArr[2])
    //const FIni = new Date(dateArr[0], dateArr[1] - 1, dateArr[2])
    //FIni.setDate(FIni.getDate() - 7) //ultimos 7 dias
    fetchData({
      Opcion: '3',
      FIni: FFin.toLocaleDateString('es-ES').split('/').reverse().map(x => x.padStart(2, '0')).join(''),
      FFin: FFin.toLocaleDateString('es-ES').split('/').reverse().map(x => x.padStart(2, '0')).join(''),
    }, FFin)


    setCurrentPage(1)
  }

  //FUNCIÓN PARA REALIZAR FETCH A LA API
  const [rawData, setRawData] = useState([])
  const fetchData = async (params, date) => {
    try {
      const response = await Axios({
        method: 'GET',
        url: url,
        headers: headers,
        params: params,
      })
      
      setRawData(response.data)
      setDateLabel(date.toLocaleDateString('es-ES'))
    } catch (err) {
      console.log(err)
    }
  }

  //FETCH INICIAL
  useEffect(() => {
    const initialFetch = () => {

      const date = new Date()
      const dateArr = date.toLocaleDateString('es-ES').split('/')
      const FFinArr = [...dateArr]
      FFinArr.splice(0, 1, String(Number(FFinArr[0] - 1))) //El primer fetch se hace el dia anterior del actual

      const label = new Date()
      label.setDate(date.getDate() - 1)

      const fInicio = FFinArr.reverse().map(x => x.padStart(2, '0')).join('')
      fetchData({
        Opcion: '3',
        FIni: fInicio,
        FFin: fInicio,
      }, label)
    }
    initialFetch()
    setLoadingAPIS(curr => ({...curr, EfectivoSinCuadrar: true}))
  }, [])

  //console.log(dateLabel)
  const data = dataFormatter(rawData)
  console.log('data: ', data)
  
    //Paginación
    const [currentPage, setCurrentPage] = useState(1)
    const recordsPerPage = 3

    const indexOfLastRecord = currentPage * recordsPerPage
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage

    const currentRecords = data.slice(indexOfFirstRecord, indexOfLastRecord)
    console.log('currentRecords: ', currentRecords)
    const nPages = Math.ceil(data.length / recordsPerPage)
    //Fin paginación
  
  return (
    <div className='bg-primarioMira pl-8 pr-11 py-5 rounded-lg'>
      <h2 className="text-lg font-medium leading-6 text-white">Cobros de efectivo por sede</h2>
      <p className="mt-1 text-sm text-grisMira">En rojo pendientes de cierre</p>
      <div className="lg:grid lg:grid-cols-12 lg:gap-x-16 pb-5">
        <div className="mt-10 text-center lg:col-start-8 lg:col-end-13 lg:row-start-1 lg:mt-9 xl:col-start-9">
          <div className="flex items-center text-white">
            <button
              type="button"
              onClick={() => navMonth(-1)}
              className="-m-1.5 flex flex-none items-center justify-center p-1.5 text-white hover:text-gray-500"
            >
              <span className="sr-only">Previous month</span>
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
            </button>
            <div className="flex-auto font-semibold">{currentMonthES.toUpperCase().charAt(0) + currentMonthES.slice(1)} {days[23].date.slice(0, 4)} </div>
            <button
              type="button"
              onClick={() => navMonth(1)}
              className="-m-1.5 flex flex-none items-center justify-center p-1.5 text-white hover:text-gray-500"
            >
              <span className="sr-only">Next month</span>
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-6 grid grid-cols-7 text-xs leading-6 text-grisMira">
            <div>D</div>
            <div>L</div>
            <div>M</div>
            <div>M</div>
            <div>J</div>
            <div>V</div>
            <div>S</div>
          </div>
          <div className="isolate mt-2 grid grid-cols-7 gap-px rounded-lg bg-gray-200 text-sm shadow ring-1 ring-gray-200">
            {days.map((day, dayIdx) => (
              <Day
                key={dayIdx}
                day={day}
                days={days}
                dayIdx={dayIdx}
                classNames={classNames}
                handleSelect={handleSelect}
              />
            ))}
          </div>
          <button
            type="button"
            onClick={()=>{handleSubmit()}}
            className="mt-8 w-full rounded-md border border-transparent bg-secundario py-2 px-4 text-sm font-medium text-white shadow hover:bg-primarioMira hover:border-2 hover:border-secundario focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
          >
            Buscar
          </button>
        </div>
        <ol className="mt-4 divide-y divide-gray-100 text-sm leading-6 lg:col-span-7 xl:col-span-8">
          {data.length === 0 ? 
          <div className='bg-secundarioMira p-5 mt-5 rounded-lg'>
            <h2 className="text-md text-grisMira">Fecha {dateLabel}</h2>
            <h2 className="text-md font-semibold text-white bg-red-500/80 mt-2 inline-block px-3 py-1 rounded-2xl">No tiene movimientos</h2>
          </div> :
            <>
            {currentRecords.map((x) => (
              (
                x.EfectivoCobrado !== null ?
                  <li key={x.IdSede} className="relative flex space-x-6 pb-2 pt-4 xl:static flex-wrap">
                    <img src={x.imageURL} alt="" className="h-14 w-14 flex-none rounded-full mx-auto mb-3 lg:mb-0" />
                    <div className="flex-auto">
                      <h3 className="pr-10 font-semibold text-white xl:pr-0">{x.Sede}</h3>
                      <dl className="mt-2 flex flex-col text-grisMira xl:flex-row">
                        <div className="flex items-start space-x-3">
                          <dt className="mt-0.5">
                            <span className="sr-only">Date</span>
                            <CalendarIcon className="h-5 w-5 text-grisMira" aria-hidden="true" />
                          </dt>
                          <dd>
                            <time dateTime={dateLabel}>
                              {dateLabel}
                            </time>
                          </dd>
                        </div>
                        <div className="mt-2 flex items-start space-x-3 xl:mt-0 xl:ml-3.5 xl:border-l xl:border-grisMira xl:border-opacity-50 xl:pl-3.5">
                          <dt className="mt-0.5">
                            <span className="sr-only">Location</span>
                            <MapPinIcon className="h-5 w-5 text-grisMira" aria-hidden="true" />
                          </dt>
                          <dd>{x.Campus}</dd>
                        </div>
                      </dl>
                    </div>
                    <div>
                      <p className={classNames(x.Cuadrado ? 'bg-green-500/80' : 'bg-red-500/80', 'm-5 py-1 px-3 rounded-full text-white font-semibold')}>
                        {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(x.EfectivoCobrado)}
                      </p>
                    </div>
                  </li>
                  : null
              )
            ))}
            <Pagination
            nPages={nPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalRecords={data.length}
            indexOfFirstRecord={indexOfFirstRecord}
            indexOfLastRecord={indexOfLastRecord}
            />
            </>
          }
        </ol>
      </div>
    </div>
  )
}

const dataFormatter = (arr) => {
  arr.map(obj => {

    const sedeName = obj.Campus.split('-')[0].trim();

    switch (sedeName) {
      case 'Calzada San Juan':
        obj.imageURL = './img/logos_sedes/SanJuan.PNG'
        break
      case 'Avenida Petapa':
        obj.imageURL = './img/logos_sedes/Petapa.PNG'
        break
      case 'Aguilar Batres':
        obj.imageURL = './img/logos_sedes/AguilarBatres.PNG'
        break
      case 'Zona 6':
        obj.imageURL = './img/logos_sedes/Zona6.PNG'
        break
      case 'San Cristóbal':
        obj.imageURL = './img/logos_sedes/SanCristobal.PNG'
        break
      case 'Villa Nueva':
        obj.imageURL = './img/logos_sedes/VillaNueva.PNG'
        break
      case 'El Naranjo':
        obj.imageURL = './img/logos_sedes/Naranjo.jpg'
        break
      default:
        break
    }
  })

  return arr

}